var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksShare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3325 20C49.4747 20 52.8325 16.6421 52.8325 12.5C52.8325 8.35786 49.4747 5 45.3325 5C41.1904 5 37.8325 8.35786 37.8325 12.5C37.8325 16.6421 41.1904 20 45.3325 20Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3325 37.5C19.4747 37.5 22.8325 34.1421 22.8325 30C22.8325 25.8579 19.4747 22.5 15.3325 22.5C11.1904 22.5 7.83252 25.8579 7.83252 30C7.83252 34.1421 11.1904 37.5 15.3325 37.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3325 55C49.4747 55 52.8325 51.6421 52.8325 47.5C52.8325 43.3579 49.4747 40 45.3325 40C41.1904 40 37.8325 43.3579 37.8325 47.5C37.8325 51.6421 41.1904 55 45.3325 55Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8076 33.775L38.8826 43.725",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8576 16.275L21.8076 26.225",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksShare);
export default __webpack_public_path__ + "static/media/how-it-works-share.76e78cbc4eda96b80a97be6961c2c3b8.svg";
export { ForwardRef as ReactComponent };